// @import
import { autoUpdate, computePosition, flip } from "@floating-ui/dom";
import { ensureHTMLElement } from "@src/js/lib/ensure";
import Alpine from "alpinejs";

import { viewport } from "@src/js/lib/viewport.js";
import { store } from "../Scene.js";
import { EquipmentIndex } from "../types.js";

Alpine.directive("equipment-dot", (element, { modifiers }, { cleanup, effect }) => {
  const equipmentId = element.getAttribute("data-equipment") as EquipmentIndex;
  if (!equipmentId) return console.warn("Trying to access uninitizialized equipment dot");

  const sceneId = modifiers[0] || "default";
  const scene = store.getScene(sceneId);
  if (!scene) return console.warn("Trying to access uninitizialized scene");

  const dom = {
    tooltip: ensureHTMLElement(
      document.querySelector(
        `.c-equipment-dot__tooltip[data-equipment='${equipmentId}'][data-scene="${sceneId}"]`,
      ),
    ),
  };

  function handleLeave() {
    if (viewport.width < 1024) return;
    scene?.unsetActiveEquipment();
  }

  effect(() => {
    const addOrRemove = ["remove", "add"][Number(scene.activeEquipment === equipmentId)];
    dom.tooltip.classList[addOrRemove]("c-equipment-dot__tooltip--open");
  });

  function handleHover() {
    if (viewport.width < 1024) return;
    scene?.setActiveEquipment(equipmentId);
  }

  function handleClick() {
    scene?.setActiveEquipment(equipmentId);
  }

  // Auto update tooltip position
  const cleanupTooltipPositionUpdate = autoUpdate(element, dom.tooltip, () => {
    computePosition(element, dom.tooltip, {
      middleware: [flip()],
      placement: "bottom",
    }).then(({ x, y }) => {
      Object.assign(dom.tooltip.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
  });

  // Event listeners
  element.addEventListener("click", handleClick);
  element.addEventListener("mouseover", handleHover);
  element.addEventListener("mouseleave", handleLeave);

  // Cleanup
  cleanup(() => {
    cleanupTooltipPositionUpdate();
    element.removeEventListener("click", handleClick);
    element.removeEventListener("mouseover", handleHover);
    element.removeEventListener("mouseleave", handleLeave);
  });
});
